export function throttle(fn, wait) {
    var time = Date.now();
    return function() {
        if ((time + wait - Date.now()) < 0) {
            fn();
            time = Date.now();
        }
    }
}

export function toggleAttribute(element, attribute) {
    if ( element.getAttribute(attribute) == 'true' ) {
        element.setAttribute(attribute, 'false');
    } else {
        element.setAttribute(attribute, 'true');
    }
}